import { jsxs as W, jsx as y } from "react/jsx-runtime";
import j, { useEffect as U, useState as z, useCallback as D, useRef as M } from "react";
const $ = {
  dev: "https://grafana-faro-collector.dev.0hash.com/collect",
  cert: "https://grafana-faro-collector.cert.zerohash.com/collect",
  prod: "https://grafana-faro-collector.zerohash.com/collect",
  "eu-cert": "https://grafana-faro-collector.cert.zerohash.eu/collect",
  "eu-prod": "https://grafana-faro-collector.zerohash.eu/collect",
  sandbox: "https://grafana-faro-collector.cert.zerohash.com/collect",
  production: "https://grafana-faro-collector.zerohash.com/collect"
}, V = (e) => {
  if (!e || typeof e != "string")
    return null;
  const t = e.split(".");
  if (t.length < 2)
    return null;
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"), r = o + "===".slice(0, (4 - o.length % 4) % 4), n = typeof atob < "u" ? atob(r) : Buffer.from(r, "base64").toString("utf-8"), c = JSON.parse(n)?.payload?.region;
    if (typeof c != "string")
      return null;
    const a = c.toLowerCase();
    return a === "us" || a === "eu" ? a : null;
  } catch {
    return null;
  }
}, A = (e, t) => V(t) !== "eu" ? e : e === "cert" ? "eu-cert" : e === "prod" ? "eu-prod" : e, P = (e) => {
  if (!e || typeof e != "string")
    return {};
  const t = e.split(".");
  if (t.length < 2)
    return {};
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"), r = o + "===".slice(0, (4 - o.length % 4) % 4), n = typeof atob < "u" ? atob(r) : Buffer.from(r, "base64").toString("utf-8"), l = JSON.parse(n), c = l?.payload ?? {}, a = (s) => typeof s == "string" && s.length > 0 ? s : void 0;
    return {
      participantCode: a(c.participant_code),
      platformName: a(c.platform_name),
      platformCode: a(l.platform_code),
      region: a(c.region)
    };
  } catch {
    return {};
  }
}, L = (e, t, o) => {
  const r = A(t, o);
  return e[r] ?? e[t] ?? e.prod;
}, J = (e, t, o) => {
  const r = A(t, o);
  return e[r] ?? e[t];
}, x = () => {
}, H = () => {
  const e = new Uint8Array(8);
  return globalThis.crypto.getRandomValues(e), Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("");
}, K = (e, t) => {
  const o = H(), r = globalThis.__ZH_WEB_SDK_VERSION__, n = {};
  e.claims.participantCode && (n.participant_code = e.claims.participantCode), e.claims.platformName && (n.platform_name = e.claims.platformName), e.claims.platformCode && (n.platform_code = e.claims.platformCode), e.claims.region && (n.region = e.claims.region), r && (n.zh_web_sdk_version = r);
  const l = {
    meta: {
      app: { name: e.appName, version: t ?? "unknown", environment: e.env },
      session: { id: o, attributes: n },
      browser: typeof navigator < "u" ? { userAgent: navigator.userAgent } : void 0,
      page: typeof window < "u" ? { url: window.location.origin } : void 0
    },
    logs: [
      {
        message: `Failed to load the script for ${e.webComponentTag} from ${e.env} environment.`,
        level: "error",
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        context: {
          web_component: e.webComponentTag,
          script_url: e.scriptUrl,
          reason: e.reason,
          tried_fallback: String(e.triedFallback),
          elapsed_ms: String(e.elapsedMs)
        }
      }
    ]
  };
  return { sessionId: o, payload: l };
}, G = (e, t, o) => {
  if (!e || typeof fetch > "u")
    return;
  const { sessionId: r, payload: n } = K(t, o);
  try {
    fetch(e, {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-faro-session-id": r },
      body: JSON.stringify(n),
      keepalive: !0
    }).catch(() => {
    });
  } catch {
  }
}, Z = (e) => {
  const { webComponentTag: t, appName: o, appVersion: r, scriptUrls: n, fallbackScriptUrls: l, collectorUrls: c, env: a, jwt: s, timeoutMs: g = 15e3, onLoad: _, onError: f } = e;
  if (typeof document > "u")
    return x;
  const d = `${t}-script-${a}`;
  if (customElements.get(t) || document.getElementById(d))
    return x;
  const b = P(s), v = e.report ?? ((p) => G(c && J(c, a, s), p, r));
  let m = !1, E = 0, C;
  const S = () => {
    C !== void 0 && clearTimeout(C);
  }, k = (p, h, i) => {
    if (m)
      return;
    const I = Math.round(performance.now() - E), N = {
      webComponentTag: t,
      appName: o,
      env: a,
      scriptUrl: h,
      reason: p,
      triedFallback: i,
      elapsedMs: I,
      claims: b
    };
    v(N);
    const O = i ? void 0 : L(l ?? {}, a, s);
    if (O && O !== h) {
      T(O, !0);
      return;
    }
    m = !0, S(), document.getElementById(d)?.remove(), f?.(N);
  }, T = (p, h) => {
    S(), E = performance.now();
    const i = document.createElement("script");
    i.id = d, i.src = p, i.type = "module", i.async = !0, i.onload = () => {
      setTimeout(() => {
        m || (customElements.get(t) ? (m = !0, S(), _?.()) : k("not-defined", p, h));
      }, 0);
    }, i.onerror = () => k("network", p, h), C = setTimeout(() => k("timeout", p, h), g), document.getElementById(d)?.remove(), document.head.appendChild(i);
  }, w = L(n, a, s);
  return w ? (T(w, !1), () => {
    m = !0, S();
  }) : x;
}, u = {
  local: "http://localhost:5173",
  dev: "https://sdk-cdn.dev.0hash.com",
  cert: "https://sdk-cdn.cert.zerohash.com",
  prod: "https://sdk-cdn.zerohash.com",
  "eu-cert": "https://sdk-cdn.cert.zerohash.eu",
  "eu-prod": "https://sdk-cdn.zerohash.eu"
}, q = (e, t, o = {}) => {
  const { eu: r = !1, legacyAliases: n = !1, local: l = u.local } = o, c = (s) => `${s}/${e}/${t}`, a = {
    local: c(l),
    dev: c(u.dev),
    cert: c(u.cert),
    prod: c(u.prod)
  };
  return n && (a.sandbox = c(u.cert), a.production = c(u.prod)), r && (a["eu-cert"] = c(u["eu-cert"]), a["eu-prod"] = c(u["eu-prod"])), a;
};
var F;
(function(e) {
  e.NETWORK_ERROR = "network_error", e.AUTH_ERROR = "auth_error", e.NOT_FOUND_ERROR = "not_found_error", e.VALIDATION_ERROR = "validation_error", e.SERVER_ERROR = "server_error", e.CLIENT_ERROR = "client_error", e.UNKNOWN_ERROR = "unknown_error";
})(F || (F = {}));
const R = {
  evergreen: "#00381D",
  green: "#CCFFD0",
  offBlack: "#1C1B1C",
  grayLight: "#EBEBE9"
}, Q = ({ onRetry: e }) => W("div", { role: "alert", style: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  maxWidth: "360px",
  margin: "0 auto",
  padding: "32px 24px",
  textAlign: "center",
  fontFamily: "inherit",
  color: R.offBlack,
  background: "#FFFFFF",
  border: `1px solid ${R.grayLight}`,
  borderRadius: "12px"
}, children: [y("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: y("path", { d: "M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z", stroke: R.evergreen, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }), y("p", { style: { margin: 0, fontSize: "16px", fontWeight: 600 }, children: "Something went wrong" }), y("p", { style: { margin: 0, fontSize: "14px", opacity: 0.75 }, children: "We couldn't load this content. Please check your internet connection and try again." }), y("button", { type: "button", onClick: e, style: {
  marginTop: "8px",
  padding: "8px 20px",
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: "inherit",
  color: R.green,
  background: R.evergreen,
  border: "none",
  borderRadius: "8px",
  cursor: "pointer"
}, children: "Try again" })] }), X = (e, t) => {
  U(() => {
    const o = e.current;
    if (o)
      for (const [r, n] of Object.entries(t))
        n !== void 0 && (o[r] = n);
  });
}, Y = (e) => {
  const { webComponentTag: t, appName: o, appVersion: r, scriptUrls: n, fallbackScriptUrls: l, collectorUrls: c, env: a, jwt: s, timeoutMs: g } = e, [_, f] = z(!1), [d, b] = z(0);
  U(() => (f(!1), Z({
    webComponentTag: t,
    appName: o ?? t,
    appVersion: r,
    scriptUrls: n,
    fallbackScriptUrls: l,
    collectorUrls: c ?? $,
    env: a,
    jwt: s,
    timeoutMs: g,
    onError: () => f(!0)
  })), [
    t,
    o,
    r,
    n,
    l,
    c,
    a,
    s,
    g,
    d
  ]);
  const v = D(() => b((m) => m + 1), []);
  return { loadFailed: _, retry: v };
}, ee = q("travel-rule-web", "index.js", { eu: !0 }), B = "zerohash-travel-rule", re = ({
  jwt: e,
  depositId: t,
  walletAddress: o,
  env: r = "prod",
  theme: n,
  onCompleted: l,
  onError: c,
  onClose: a,
  onLoaded: s,
  onEvent: g,
  ..._
}) => {
  const f = M(null);
  X(f, {
    theme: n,
    depositId: t,
    walletAddress: o,
    onCompleted: l,
    onError: c,
    onClose: a,
    onLoaded: s,
    onEvent: g
  });
  const { loadFailed: d, retry: b } = Y({
    webComponentTag: B,
    scriptUrls: ee,
    env: r,
    jwt: e
  });
  return d ? /* @__PURE__ */ y(Q, { onRetry: b }) : j.createElement(B, {
    ref: f,
    jwt: e,
    env: r,
    theme: n,
    // camelCase — React 19 sets this as a property via the extra-prop setter
    // before connectedCallback runs, so the value lands in the URL fragment
    // reliably (the hyphenated attribute path fails for JSON extra props
    // because the raw string isn't valid JSON).
    depositId: t,
    walletAddress: o,
    ..._
  });
};
export {
  re as TravelRule
};
